import { useState } from 'react';
import { Alert, Button, Form, Modal } from 'react-bootstrap';
import { collectCash } from '../api';

// v3_fix_issues #13 - the delivery person records the cash they collected for a Cash-on-Delivery
// booking. The reference is the receipt / acknowledgement number - a payment is never recorded as
// received without it. Finance still reconciles the entry afterwards.
export default function CollectCashModal({ booking, show, onHide, onCollected }) {
  const [reference, setReference] = useState('');
  const [note, setNote] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const close = () => {
    onHide();
    setTimeout(() => { setReference(''); setNote(''); setError(''); }, 300);
  };

  const submit = async (e) => {
    e.preventDefault();
    if (reference.trim().length < 2) {
      setError('Enter the cash receipt / acknowledgement number');
      return;
    }
    setBusy(true);
    setError('');
    try {
      await collectCash(booking._id, { reference: reference.trim(), note: note.trim() || undefined });
      onCollected();
      close();
    } catch (err) {
      setError(err.response?.data?.msg || 'Unable to record the cash payment.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal show={show} onHide={close} centered>
      <Modal.Header closeButton>
        <Modal.Title as="h5">Record cash collected</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {booking && (
          <p className="mb-3">
            Collecting <strong>₹{(booking.codAmountDue || 0).toLocaleString('en-IN')}</strong> in cash
            from {booking.customerName} for order #{String(booking._id).slice(-6).toUpperCase()}.
          </p>
        )}
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={submit}>
          <Form.Group className="mb-2">
            <Form.Label className="small mb-0">Receipt / acknowledgement number *</Form.Label>
            <Form.Control
              size="sm" aria-label="Receipt reference"
              value={reference} onChange={(e) => setReference(e.target.value)}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="small mb-0">Note (optional)</Form.Label>
            <Form.Control size="sm" aria-label="Note" value={note} onChange={(e) => setNote(e.target.value)} />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2">
            <Button size="sm" variant="outline-secondary" onClick={close}>Cancel</Button>
            <Button size="sm" type="submit" variant="success" disabled={busy}>
              {busy ? 'Saving…' : 'Confirm cash received'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
